import { useState } from 'react';
import { Link } from 'react-router-dom';
import {
    ArrowRight,
    CheckCircleFill,
    Envelope,
    ExclamationTriangleFill,
    Key,
    ShieldLock,
} from 'react-bootstrap-icons';

import api_url from '../config/api_url';

const getCookieOptions = () => (
    window.location.protocol === 'https:'
        ? 'Path=/; SameSite=None; Secure'
        : 'Path=/; SameSite=Lax'
);

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [status, setStatus] = useState('idle');
    const [statusMessage, setStatusMessage] = useState('');
    const isSubmitting = status === 'loading';
    const isSuccess = status === 'success';
    const isError = status === 'error';

    const handleSubmit = async (event) => {
        event.preventDefault();
        setStatus('loading');
        setStatusMessage('');

        try {
            const response = await fetch(`${api_url}api/user/authenticate`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ user: { email, password } }),
            });
            const json = await response.json();

            if (!response.ok || json.error || !json.email || !json.session_token) {
                setStatus('error');
                setStatusMessage('Email eller adgangskode passer ikke.');
                return;
            }

            const cookieOptions = getCookieOptions();
            document.cookie = `email=${encodeURIComponent(json.email)}; ${cookieOptions}`;
            document.cookie = `session_token=${encodeURIComponent(json.session_token)}; ${cookieOptions}`;
            setStatus('success');
            setStatusMessage('Du er logget ind.');
        } catch {
            setStatus('error');
            setStatusMessage('Vi kunne ikke kontakte serveren. Prøv igen om lidt.');
        }
    };

    return (
        <main className="login-page" aria-labelledby="login-title">
            <section className="login-hero">
                <div className="login-hero-copy">
                    <span className="login-kicker">Budgetvenlig konto</span>
                    <h1 id="login-title">Log ind på Budgetvenlig</h1>
                    <p>
                        Gem dine rester i dit spisekammer og dine lokale tilbudsvalg, så ugens bedste tilbud passer til dig.
                    </p>
                </div>

                <form className="login-panel" onSubmit={handleSubmit} noValidate>
                    <div className="login-panel-header">
                        <span className="login-panel-icon" aria-hidden="true">
                            <ShieldLock size={22} />
                        </span>
                        <div>
                            <h2>Dine madplaner</h2>
                            <p>Fortsæt med dine gemte butikker, adresse og radius.</p>
                        </div>
                    </div>

                    <div
                        className={`login-alert${isError ? ' is-error' : ''}${isSuccess ? ' is-success' : ''}${!statusMessage ? ' d-none' : ''}`}
                        role={isError ? 'alert' : 'status'}
                        aria-live="polite"
                    >
                        {isError && <ExclamationTriangleFill size={16} aria-hidden="true" />}
                        {isSuccess && <CheckCircleFill size={16} aria-hidden="true" />}
                        <span>{statusMessage}</span>
                    </div>

                    <label className="login-field" htmlFor="login-email">
                        <span>Email</span>
                        <div className="login-input-wrap">
                            <Envelope size={18} aria-hidden="true" />
                            <input
                                id="login-email"
                                type="email"
                                value={email}
                                onChange={(event) => setEmail(event.target.value)}
                                autoComplete="email"
                                placeholder="din@email.dk"
                                required
                            />
                        </div>
                    </label>

                    <label className="login-field" htmlFor="login-password">
                        <span>Adgangskode</span>
                        <div className="login-input-wrap">
                            <Key size={18} aria-hidden="true" />
                            <input
                                id="login-password"
                                type="password"
                                value={password}
                                onChange={(event) => setPassword(event.target.value)}
                                autoComplete="current-password"
                                placeholder="Indtast adgangskode"
                                required
                            />
                        </div>
                    </label>

                    <button className="login-submit" type="submit" disabled={isSubmitting}>
                        <span>{isSubmitting ? 'Logger ind...' : 'Log ind'}</span>
                        <ArrowRight size={18} aria-hidden="true" />
                    </button>

                    {isSuccess && (
                        <Link className="login-admin-link" to="/profile">
                            Gå til din profil
                        </Link>
                    )}
                </form>
            </section>
        </main>
    );
}

export default Login;
